import { ChevronRight, MoreHorizontal, Pencil } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { PARSE_PENDING } from '@/models/document'
import type { DocumentsTableDocument } from './types'
import type { DocumentRowActions } from './useDocumentRowActions'

/**
 * The Details CTA and the rename menu for one document.
 *
 * Both endpoints are org-scoped, so a document with no org — a lead's
 * pre-conversion upload — gets neither, and the cell renders empty.
 */
export function DocumentActions({
  document,
  openDetails,
  openRename,
}: { document: DocumentsTableDocument } & DocumentRowActions) {
  if (!document.org) return null

  const isPending = document.parseStatus === PARSE_PENDING

  return (
    <div className="flex items-center justify-end gap-1">
      <Button variant="outline" size="sm" onClick={() => openDetails(document)} disabled={isPending}>
        Details
        <ChevronRight className="size-3.5" />
      </Button>
      {openRename && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon-sm" aria-label={`Actions for ${document.displayName}`}>
              <MoreHorizontal className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => openRename(document)}>
              <Pencil className="size-4" />
              Rename
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  )
}
